module.exports = __webpack_public_path__ + "img/seo-content-collapsible-nissan.a9bc52ec.png";